<template>
  <div style="padding:20px;">
    <el-row>
      <el-col :span="24">
        <el-button
            style="padding: 0; margin: 20px"
            type="text"
            icon="el-icon-back"
            @click="backPrePage()"
        >
          返回
        </el-button>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-form ref="form" :model="form" label-width="150px" :disabled="formLoading">
        <el-row>
          <el-col :span="24">
            <el-form-item label="标题" prop="title">
              <el-input
                  v-model="form.title"
                  maxlength="30"
                  show-word-limit
                  style="width:33%"
              ></el-input>
            </el-form-item>
            <el-form-item label="图片">
              <activityCustomUpload :formName="'img_url'" :formValue="form.img_url"
                                    @uploadSuccess="uploadSuccess"></activityCustomUpload>
              <div>
                只能上传jpg/png文件<br>
                仅支持”运营H5活动地址“跳转
              </div>
            </el-form-item>

            <banner-target ref="bannerTarget" :target="form.target" :address="form.address"
                           :target_msg="form.target_msg" :target_id="form.target_id" :source_type="source_type"></banner-target>

          </el-col>
        </el-row>


        <el-form-item>
          <el-button type="primary" :loading="onSaveLoading" @click="onSave">保存</el-button>
          <el-button @click="backPrePage()">取消</el-button>
        </el-form-item>
      </el-form>
    </el-row>
  </div>
</template>
<script>
import {
  getItemInfo, updateCouponInfo
} from "@/api/mall";
import bannerTarget from '@/components/bannerTarget.vue';
import activityCustomUpload from "@/components/activityCustomUpload.vue";

export default {
  components: {bannerTarget, activityCustomUpload},
  data: function () {
    return {
      id: '',
      info: {},
      source_type: 0,
      form: {
        title: '',
        img_url: '',
        target: 'target_h5',
        address: '',
        target_msg: '',
        target_id: '',
      },
      ossAction: "",
      formLoading: false,
      onSaveLoading: false,
    }
  },
  created: function () {
    this.id = this.$route.query.id;
    this.form.module_id = this.$route.query.module_id;
    if (this.id != 0) {
      this.getInfo();
    }else{
      this.form.id = 0;
    }
  },
  methods: {
    getInfo() {
      this.formLoading = true;
      getItemInfo({
        id: this.id
      }).then(response => {
        this.formLoading = false
        this.form = response.data
      });
    },
    uploadSuccess(value) {
      this.form[value.formName] = value.fileUrl
    },
    onSave() {
      this.onSaveLoading = true;
      let that = this
      this.form.target = this.$refs.bannerTarget.theTarget;
      this.form.address = this.$refs.bannerTarget.theAddress;
      this.form.target_id = this.$refs.bannerTarget.theTargetId;

      updateCouponInfo(this.form).then(res => {
        that.onSaveLoading = false;
        if (res.code == 1) {
          that.$message({
            showClose: true,
            duration: 6000,
            message: '保存成功',
            type: 'success'
          });
          that.backPrePage();
        }
      });

    },
    backPrePage() {
      this.$router.go(-1);
    }
  },
}
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  min-height: 70px;
  line-height: 70px;
  text-align: center;
}

.avatar {
  width: 100px;
  min-height: 40px;
  display: block;
}
</style>